/* eslint-disable react/prop-types */
import { Redirect, Route, useParams } from "react-router-dom";
import React from "react";

const hasRequiredPermission = (permissions, perform = [], condition = true) => {
  if (!permissions || !condition) {
    return false;
  }

  const actions = Array.isArray(perform) ? perform : [perform].filter(Boolean);

  return (
    actions.length === 0 ||
    actions.some((action) => Object.hasOwn(permissions, action))
  );
};

const ProtectedRouteContent = ({
  component: Component,
  customprops = {},
  parentProps = {},
}) => {
  const params = useParams();

  return <Component {...params} {...customprops} {...parentProps} />;
};

const ProtectedRoute = ({
  component,
  perform = [],
  permissions,
  customprops = {},
  parentProps = {},
  condition = true,
  ...rest
}) => {
  if (!hasRequiredPermission(permissions, perform, condition)) {
    return <Redirect to="/" />;
  }

  return (
    <Route {...rest}>
      <ProtectedRouteContent
        component={component}
        customprops={customprops}
        parentProps={parentProps}
      />
    </Route>
  );
};

export default ProtectedRoute;
